module.exports = __webpack_public_path__ + "e21b7cb072ec11f99a042929d3c69daa.png";